var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonVideoPlayGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 56 56"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 577",
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#fff",
  opacity: 0.9
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 35.827V19.645a1.547 1.547 0 01.495-1.183A1.638 1.638 0 0123.65 18a1.7 1.7 0 01.432.059 1.746 1.746 0 01.432.179l12.737 8.109a1.7 1.7 0 01.562.613 1.648 1.648 0 01.187.777 1.648 1.648 0 01-.187.777 1.7 1.7 0 01-.562.613l-12.737 8.109a1.753 1.753 0 01-.433.179 1.7 1.7 0 01-.433.06 1.635 1.635 0 01-1.154-.462A1.549 1.549 0 0122 35.827z",
  fill: "#999"
})));
export default __webpack_public_path__ + "static/button-video-play-grey.942733fcc3bc49557dc7e2a96f5aa6de.svg";
export { SvgButtonVideoPlayGrey as ReactComponent };